import { api2 , apiUpload } from './ApiService';

export default class MobileService {
    
    static async get(){
        let response =  await api2.get(`/api/v1/mobile`)
        return response.data
    }


    static async search(key,page,perpage){
        let data ={
            key: key,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/mobile/search`,data)
        return response.data
    }
 
    static async create(formData){
        let response = await apiUpload.post(`/api/v1/mobile/create`,formData)
        return response.data
    }
    static async update(formData){
        let response = await apiUpload.post(`/api/v1/mobile/update`,formData)
        return response.data
    }
    static async delete(data){
        let response = await api2.post(`/api/v1/mobile/delete`,data)
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/MobileService.js